import { render, staticRenderFns } from "./SchedulingEventDisplay.vue?vue&type=template&id=44dde1cd"
import script from "./SchedulingEventDisplay.vue?vue&type=script&lang=js"
export * from "./SchedulingEventDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports